export const REINDEX_ACTIVE_STATUSES = ["PENDING", "PROCESSING"] as const;

export function hasActiveReindex(statuses: string[]): boolean {
  return statuses.some((status) =>
    (REINDEX_ACTIVE_STATUSES as readonly string[]).includes(status),
  );
}

export function hasRunningReindex(statuses: string[]): boolean {
  return statuses.includes("PROCESSING");
}

export function selectedDocumentIds(formData: FormData): string[] {
  const ids: string[] = [];
  const seen = new Set<string>();
  for (const value of formData.getAll("documentId")) {
    if (typeof value !== "string" || value.length === 0 || seen.has(value)) {
      continue;
    }
    seen.add(value);
    ids.push(value);
  }
  return ids;
}

export function indexingVersion<
  T extends { id: string; jobs: Array<{ status: string }> },
>(versions: T[], currentVersionId: string | null): T | undefined {
  const active = versions.find((version) =>
    hasActiveReindex(version.jobs.map((job) => job.status)),
  );
  if (active) {
    return active;
  }
  return (
    versions.find((version) => version.id === currentVersionId) ?? versions[0]
  );
}

export function selectableDocumentIds(
  rows: Array<{ id: string; canWrite: boolean }>,
): string[] {
  return rows.filter((row) => row.canWrite).map((row) => row.id);
}
